export const getNextWeek = (t: any) => {
  let v: any = `${new Date().getFullYear()}-${
    new Date().getMonth() + 1
  }-${new Date().getDate()}`;
  //날짜스트링과, 일차를 파라메터로 받는다
  var str = []; //배열
  var b = v.split("-"); //날짜를 - 구분자로 나누어 배열로 변환
  var c = new Date(b[0], b[1] - 1, b[2]); //데이트객체 생성
  var d = c.valueOf() + 1000 * 60 * 60 * 24 * t; //t일후, (음수면 전일)의 타임스탬프를 얻는다
  var e = new Date(d); //의뢰한날의 데이트객체 생성

  str[str.length] = e.getFullYear(); //년
  str[str.length] = `${
    e.getMonth() + 1 > 10 ? e.getMonth() + 1 : `0${e.getMonth() + 1}`
  }`; //월
  str[str.length] = e.getDate() >= 10 ? e.getDate() : `0${e.getDate()}`; //일
  return str.join("-"); //배열을 - 구분자로 합쳐 스트링으로 변환후 반환
};
